import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubMessage } from '../types/hub-message';

@Component({
  selector: 'messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css'],
  providers: [HubService],
})

export class MessagesComponent implements OnInit {
  @Input() inHub: Hub;
  hub_messages = <HubMessage[]>[];
  fromMessages = <number[]>[];
  private allMessages = <HubMessage[]>[];

  private messagesBefore: number = null;
  errorMessage: string;
  public messageMenuFlag = false;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('Hub Message: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (!this.inHub) { this.inHub = new Hub(); }
    this.refresh();
  }

  onMailSent(messageSent: boolean): void {
    if (messageSent) {
      this.refresh();
    }
  }

  getMessageType(msg: HubMessage): any {
    switch (msg.mail_type) {
      case 2:
        return 'Reorder';
      case 1:
        return 'Question';
      case 0:
        return 'Information';
      default:
        return 'Information';
    }
  }

  getReadClass(msg: HubMessage): string {
    if (msg.time_read) {
      return "message_read";
    }
    return "message_unread";
  }

  get_message_response(msg: HubMessage): any {
    switch (msg.mail_type) {
      case 2:
      case 1:
        if (msg.time_read) {
          return (msg.response ? msg.positive : msg.negative);
        } else {
          return null;
        }
      case 0:
        return (msg.time_read || msg.response ? 'Read' : null);
      default:
        return null;
    }
  }

  earlier(): void {
    let msgID: number = null;
    try {
      msgID = this.hub_messages[this.hub_messages.length - 1].uid;
      if (!this.fromMessages) {
        this.fromMessages = <number[]>[];
      }
      this.fromMessages.push(this.hub_messages[0].uid)
    } catch (err) {
      console.log(err);
    }
    this.messagesBefore = msgID;
    this.refresh()
  }

  later(): void {
    let msgID: number = null;
    try {
      msgID = this.fromMessages[this.fromMessages.length - 1];
      this.fromMessages = this.fromMessages.slice(0, -1);
    } catch (err) { }
    this.messagesBefore = msgID;
    this.refresh()
  }

  readTime(msg: HubMessage): any {
    if (msg.time_read == null) {
      return null;
    }
    let d = new Date(0);
    // The 0 there is the key, which sets the date to the epoch
    // return (d.setUTCSeconds(+msg.time_read + 946681200));
    return (d.setUTCSeconds(+msg.time_read));
  }

  newMessage(): void {
    // console.log('Making new message pane visible');
    this.messageMenuFlag = !this.messageMenuFlag;
    // document.getElementById('new_message').style.display = 'block';
  }

  updateMessage(messages: HubMessage[]): void {
    this.allMessages = messages;
    this.hub_messages = messages;
  }

  refresh(): void {
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getMessages(+params['hubid'], this.messagesBefore, null))
    ).subscribe(
      (messages: HubMessage[]) => this.updateMessage(messages),
      err => MessagesComponent.handleRefreshError(err)
    );
  }
}


